import '@ep/app/chunkRecovery';
import { applyStoredVisualPreferences } from '@ep/tools/visualPreferences';
import { Render } from './router';

/* ===== API publica ===== */
/**
 * Ponto de entrada da aplicação web.
 * @public
 */
applyStoredVisualPreferences();
Render();
